import {RouteConfig} from 'vue-router'
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue'
import StatisticsList from '@/pages/Statistics/StatisticsList.vue'

// @ts-ignore
import messages from '@/lang/index';

const statistics: RouteConfig = {
  path: '/statistics',
  name: 'statistics',
  meta: {
    pageName: messages.employees.page_name
  },
  component: DashboardLayout,
  redirect: '/statistics/list',
  children: [
    {
      path: 'list',
      name: 'statisticsList',
      meta: {
        pageName: messages.employees.list
      },
      component: StatisticsList
    }
  ]
}
export default statistics